fragment SmsDeliverabilityFragment on SmsDeliverabilityStatus {
    status
    optOutTime
}
